<template>
  <div
    v-editable="blok"
    class="my-8 grid overflow-hidden rounded-3xl shadow-lg sm:grid-cols-2 md:my-12 lg:-mx-32"
  >
    <div class="bg-green-800 px-6 py-8 sm:w-full sm:pl-12 lg:py-12 lg:pl-16">
      <div class="tag-on-dark mb-4">{{ blok.tag }}</div>
      <h2
        class="nimpkish mb-6 text-2xl !tracking-wide !text-lemon-200 lg:text-4xl"
      >
        {{ blok.heading }}
      </h2>
      <p class="mb-6 text-base text-white lg:text-lg">
        {{ blok.body }}
      </p>
      <BtnHero
        :label="blok.buttonLabel"
        :url="blok.buttonURL"
        size="large"
        arrow="right"
        class="max-md:w-full"
      />
      <div v-if="blok.disclaimer" class="mt-6 [&_*]:text-sm [&_*]:text-white">
        <SbUtilRichTextRender :article-content="blok.disclaimer" />
      </div>
    </div>

    <div
      class="bg-image bg-radial relative row-start-1 flex min-h-[18rem] w-full flex-col items-start justify-end bg-cover bg-center before:absolute before:left-0 before:top-0 before:block before:h-full before:w-full sm:col-start-2 sm:h-auto sm:w-full sm:bg-right"
    >
      <svg
        class="absolute bottom-0 h-8 w-full -scale-y-100 transform text-green-800 sm:left-0 sm:top-0 sm:h-full sm:w-8 lg:w-16"
        :class="blok.invertedCurve ? '' : 'sm:scale-y-100'"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        viewBox="0 0 64 440"
        aria-hidden="true"
      >
        <path
          d="M0,440.43V0H64c-16.16,54.89-31.15,116.88-42.56,185.29C5.62,280.1,.19,366.28,0,440.43Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { ISbRichtext } from "storyblok-js-client";

const props = defineProps<{
  blok: {
    tag: string;
    heading: string;
    body: string;
    buttonLabel: string;
    buttonURL: string;
    disclaimer?: ISbRichtext;
    backgroundImage: {
      filename: string;
    };
    invertedCurve?: boolean;
  };
}>();

const backgroundImageURL = `url('${props.blok.backgroundImage.filename}/m/720x0/smart/')`;
</script>
<style scoped>
.bg-radial::before {
  background: radial-gradient(
    ellipse at top right,
    rgba(19, 50, 43, 0) 35%,
    rgba(19, 50, 43, 0.8) 85%
  );
}

.bg-image {
  background-image: v-bind("backgroundImageURL");
}
</style>
